export default "__VITE_ASSET__QAyeIfNh__"